export const POLARITY = {
  HIGHER_IS_BETTER: 'higher_is_better',
  LOWER_IS_BETTER: 'lower_is_better',
};

export const DELTA_FORMAT = {
  PERCENTAGE_POINTS: 'percentage_points',
  ABSOLUTE: 'absolute',
  MULTIPLIER: 'multiplier',
  CURRENCY_WITH_MULTIPLIER: 'currency_with_multiplier',
};

export const INDUSTRY_COMPARISON_GROUPS = [
  {
    name: 'Adoption & Satisfaction',

    metrics: [
      {
        label: 'Enrollment Rate',
        metricId: 'enrollment_l30d',
        polarity: POLARITY.HIGHER_IS_BETTER,
        deltaFormat: DELTA_FORMAT.PERCENTAGE_POINTS,
      },
      {
        label: 'Positive Employer Sentiment',
        metricId: 'employer_sentiment_positive_l30d',
        polarity: POLARITY.HIGHER_IS_BETTER,
        deltaFormat: DELTA_FORMAT.PERCENTAGE_POINTS,
      },
      {
        label: 'New Joiner Activation Rate',
        metricId: 'new_joiner_conversion_l30d',
        polarity: POLARITY.HIGHER_IS_BETTER,
        deltaFormat: DELTA_FORMAT.PERCENTAGE_POINTS,
      },
    ],
  },
  // Hidden due to data issues with non-enrolled/all tenure metrics
  // {
  //   name: 'Retention & Tenure',
  //   metrics: [
  //     { label: 'Average Employee Tenure', metricId: 'tenure_avg_months_all', ... },
  //     { label: '24-Month Retention (All)', metricId: 'tenure_over_24m_all', ... },
  //     { label: '12-Month Retention (All)', metricId: 'tenure_over_12m_all', ... },
  //   ],
  // },
  {
    name: 'Product Engagement',

    metrics: [
      {
        label: 'Daily Active Users (DAU)',
        metricId: 'dau_from_enrolled',
        polarity: POLARITY.HIGHER_IS_BETTER,
        deltaFormat: DELTA_FORMAT.PERCENTAGE_POINTS,
      },
      {
        label: 'Monthly Active Users (MAU)',
        metricId: 'mau_from_enrolled',
        polarity: POLARITY.HIGHER_IS_BETTER,
        deltaFormat: DELTA_FORMAT.PERCENTAGE_POINTS,
      },
    ],
  },
  // Operational Efficiency group removed — internal operational metrics not suitable for client-facing impact view
];

export const WORKFORCE_IMPACT_GROUPS = [
  {
    name: 'Retention & Tenure — The Core Impact Story',

    metrics: [
      {
        label: 'Employee Turnover (Monthly)',
        enrolledMetricId: 'enrolled_turnover_l30d',
        nonEnrolledMetricId: 'non_enrolled_turnover_l30d',
        polarity: POLARITY.LOWER_IS_BETTER,
        deltaFormat: DELTA_FORMAT.PERCENTAGE_POINTS,
      },
      // Hidden due to data issues with non-enrolled tenure metrics
      // { label: 'Average Employee Tenure', enrolledMetricId: 'tenure_avg_months_enrolled', nonEnrolledMetricId: 'tenure_avg_months_non_enrolled', ... },
      // { label: '24-Month Retention', enrolledMetricId: 'tenure_over_24m_enrolled', nonEnrolledMetricId: 'tenure_over_24m_non_enrolled', ... },
      // { label: '12-Month Retention', enrolledMetricId: 'tenure_over_12m_enrolled', nonEnrolledMetricId: 'tenure_over_12m_non_enrolled', ... },
      // { label: '6-Month Retention', enrolledMetricId: 'tenure_over_6m_enrolled', nonEnrolledMetricId: 'tenure_over_6m_non_enrolled', ... },
    ],
  },
  {
    name: 'Financial Wellness Impact',

    metrics: [
      {
        label: 'Avg Savings per Enrolled Employee',
        enrolledMetricId: 'savings_balance_per_enrolled',
        nonEnrolledMetricId: null,
        nonEnrolledDisplay: 'sector',
        polarity: POLARITY.HIGHER_IS_BETTER,
        deltaFormat: DELTA_FORMAT.CURRENCY_WITH_MULTIPLIER,
      },
    ],
  },
];
